import React from "react";

export const LazySelectBridge = React.lazy(
    () => import(/* webpackChunkName: "FormControls" */ "./Select")
);
